import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {useLicenseTypes} from 'src/hooks/dictionaries';

import {
    userConferencesLicenseDataSelector,
    userConferencesLicenseResultSelector,
} from '../../slices/user-conferences-license.slice';

type Props = {
    accountId: number,
};

export const LicenseTypeCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(userConferencesLicenseDataSelector);
    const result = useSelector(userConferencesLicenseResultSelector);
    const {getLicenseTypeByCode} = useLicenseTypes();

    const licenseType = useMemo(() => {
        if (!result?.data[accountId]) {
            return undefined;
        } else {
            return getLicenseTypeByCode(result?.data[accountId].licenseType) || '';
        }
    }, [result, accountId, getLicenseTypeByCode]);

    if (isLoading || loadingError || !licenseType) {
        return null;
    }

    return (
        <span>{licenseType}</span>
    );
};
